module.exports = __webpack_public_path__ + "img/canara.c2fe4e1a.jpg";